import React, {Component} from 'react'
import {Helmet} from 'react-helmet'
import ReactGA from 'react-ga'
import './HomepageComponent.css'
import RowContent from '../RowContent'
import MusicAlgoNav from '../MusicAlgoNav'
import MusicAlgoFooter from '../MusicAlgoFooter'
import {Grid, Row, Col, Jumbotron} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/css/bootstrap-theme.css'

ReactGA.initialize('UA-75058203-1');
ReactGA.pageview(window.location.pathname + window.location.search);

const colStyle = {minHeight: "100px", height: "90%"};
const styleGrid = {width: "100%"};            

class HomepageComponent extends Component {
  render() {
    return (
      <div className="App">
        <Helmet>
            <meta name="description" content="Don't let your knowledge escape! An innovative approach to learning and remembering algorithm fundamentals." />
        </Helmet>
        <div className="cont">
        
        
        <Jumbotron style={{marginBottom:"0"}}>
            <Grid style={{...styleGrid}}>
                <Row className="Row">
                    <Col lg={6} style={{...colStyle, color:"white"}}> 
                        <div style={{margin:"auto", marginTop:"30px"}}>
                            <h1 className="titleHeader" id="bigHeading">Don't let your knowledge escape!</h1>
                            <p id="bigHeadingComment">Learn algorithm fundamentals with intuitive explanations, animated examples, and musical mnemonics.</p>
                        </div>
                    </Col>
                    <Col lg={6} style={{...colStyle}}>
                        <div style={{maxWidth:"440px", margin:"auto"}}>
                            <img src="colorfulBrain.png" alt="MusicAlgo" style={{width:"85%"}}/>
                        </div>
                    </Col>
                </Row>
            </Grid>
        </Jumbotron>
        <h2 style={{marginTop:"60px"}}>The MusicAlgo Approach</h2>
        <p style={{fontSize:"2rem",
                   marginBottom:"50px"
                   }}>A logical ordering of concepts to make ideas stick</p>

        <Grid style={{...styleGrid, width:"75%"}}>
            <RowContent colHeader="Intuition"
                imgSrc="binarySearchIntGif.gif"
                divColor="#90ef90"
                explanation="Understand how an algorithm works by learning to perform it by hand with step by step animated demonstrations, and instructions in plain English. No coding background or advanced mathematics are necessary, just bring your thinking cap!" />

            <RowContent colHeader="Analysis" 
                imgSrc="binarySearchAnaGif.gif"
                divColor="#b365ff"
                explanation="Learn how to analyze the complexity of an algorithm with big-O notation and then apply the process to the topic algorithm." />
        
            <RowContent colHeader="Song and Code" 
                imgSrc="binarySearchS&CGif.gif"
                divColor="orange"
                explanation="Hear the MusicAlgo, which takes rhymes the algorithm pseudocode to a melody which can help you recall the intuition behind the algorithm whenever you need it!" />       
        </Grid>
        </div>
        
      </div>
    )
  }
}
export default HomepageComponent


// WEBPACK FOOTER //
// ./src/HomepageComponent/HomepageComponent.js